"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorInput = void 0;
const react_1 = require("@remirror/react");
const react_2 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const EditorInput = ({ container, ...other }) => {
    const { getRootProps } = (0, react_1.useRemirrorContext)();
    const { key, ...rootProps } = getRootProps();
    const preventImagePaste = (0, react_2.useCallback)((event) => {
        const { clipboardData } = event;
        const pastedData = clipboardData?.files[0];
        if (pastedData?.type &&
            pastedData?.type.startsWith('image/') &&
            // Still allow paste of any text that came through (Word, etc)
            !clipboardData?.types.includes('text/plain')) {
            event.preventDefault();
        }
        // Allow other paste event handlers to be run.
        return false;
    }, []);
    const input = react_2.default.createElement("div", { key: key, ...rootProps, ...other });
    (0, react_1.useEditorEvent)('paste', preventImagePaste);
    return container ? (0, react_dom_1.createPortal)(input, container) : input;
};
exports.EditorInput = EditorInput;
